import React, {Component} from 'react';
import {connect} from 'react-redux';
import AiYearLogo from '../AiYearLogo';
import SocialLink from '../SocialLink';

class KsuTwoTemplateRtl extends Component {

	render() {
		return (

			<div style={{direction:'rtl', textAlign:'right', minWidth:'600px', maxWidth:'600px', width: '600px', display: 'flex'}} data-signature-root="true">
					<div style={{width: "150px", flex: '0 0 150px', textAlign: 'center'}}>
						<img style={{width: "100px"}} src={this.props.imageName} alt={this.props.name}/>
					</div>
					<div style={{width: 'auto'}}>
							<div style={{fontSize: 15, fontWeight: 'bold'}}>
								{!this.props.flag ? 'محمد عبدالله' : this.props.name}
							</div>
							<div>
								{!this.props.flag ? 'الوظيفة  |  ' : this.props.jobTitle} {this.props.jobTitle === '' ? '' : '  |  '}
								{!this.props.flag ? 'القسم' : this.props.department}
							</div>
							<div>
								{!this.props.flag ?
									<>
										<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} />
										&nbsp;
										011/055
									</> :
									<>
										<img style={{width: '15px'}} src={`${process.env.PUBLIC_URL}/mobile.png`} alt={'mobile'} hidden={this.props.mobile === ''}/>
										&nbsp;
										{this.props.mobile}
									</>}
							</div>
							<div style={{height: 2, fontSize: 2, lineHeight: '2px'}}>&nbsp;</div>
							<div>
								{!this.props.flag ?
									<>
										<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'}/>
										&nbsp;
										m.abdullah@ksu.edu.sa
									</> :
									<>
										<img style={{width:'15px'}} src={`${process.env.PUBLIC_URL}/email.png`} alt={'email'} hidden={this.props.email === ''}/>
										&nbsp;
										{this.props.email}
									</>}
							</div>
							<div style={{height: 2, fontSize: 2, lineHeight: '2px'}}>&nbsp;</div>

							<div style={{height: 2, fontSize: 2, lineHeight: '2px'}}>&nbsp;</div>
							<div style={{color: '#1da1f2'}}>
								{!this.props.flag ? 'https://ksu.edu.sa' : this.props.website}
							</div>
							<div style={{display:'inline-block'}}>
								<div style={{display: 'inline-flex', alignItems: 'center'}}>
									<img src={`${process.env.PUBLIC_URL}/ksu_logo_foot.png`} className='mt-2' width="120px" height="45px" style={{marginLeft: '10px', padding: 0, border: 'none', display: 'inline-block'}} border={0} alt={'ksu-logo'}/>
									<AiYearLogo style={{width: '95px', display: 'inline-block', verticalAlign: 'middle'}}/>
								</div>

								<div className='d-flex flex-wrap align-items-center' style={{gap: '5px', marginTop: '4px'}}>
									{!this.props.flag ?
										<div className='d-inline mr-2'>
											<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com'>
												<img className='mr-1' style={{width:'25px'}} src={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'}/>
											</a>
										</div>
										: (this.props.linkedin !== '' && <SocialLink href={this.props.linkedin} icon={`${process.env.PUBLIC_URL}/linkedin.png`} alt={'linkedin'} width={'25px'}/>)}
									{!this.props.flag ?
										<div className='d-inline mr-2'>
											<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.x.com'>
												<img className='mr-1' style={{width:'25px'}}  src={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'}/>
											</a>
										</div>
										: (this.props.twitter !== '' && <SocialLink href={this.props.twitter} icon={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'} width={'25px'}/>)}

									{!this.props.flag ?
										<div className='d-inline mr-2'>
											<a className='d-flex align-items-center' target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/'>
												<img className='mr-1' style={{width:'25px'}}  src={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'}/>
											</a>
										</div>
										: ( this.props.facebook !== '' && <SocialLink href={this.props.facebook} icon={`${process.env.PUBLIC_URL}/facebook.png`} alt={'facebook'} width={'25px'}/>)}

									{/* {!this.props.flag ?
										(<a target="_blank" rel="noopener noreferrer" href='https://www.github.com/'><img style={{width: '25px'}} src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>
										): (this.props.github !== '' && <a target="_blank" rel="noopener noreferrer" href={this.props.github}><img style={{width:'25px'}}  src={`${process.env.PUBLIC_URL}/github.png`} alt={'github'}/></a>)}&nbsp;&nbsp; */}
								</div>
							</div>
					</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		flag: state.ArabicReducer.flag,
		name: state.ArabicReducer.ar_name,
		email: state.ArabicReducer.ar_email,
		jobTitle: state.ArabicReducer.ar_jobTitle,
		department: state.ArabicReducer.ar_department,
		mobile: state.ArabicReducer.ar_mobile,
		website: state.ArabicReducer.ar_website,
		imageName: state.imageReducer.image,
		linkedin: state.socialReducer.linkedin,
		twitter: state.socialReducer.twitter,
		facebook: state.socialReducer.facebook,
		github: state.socialReducer.github,
	};
}

export const ksuTwoTemplateRtl = connect(mapStateToProps)(KsuTwoTemplateRtl);
